<template>
<div class="pagination">
  <paginate
    v-model="page"
    :page-count="pagination.pageCount"
    :prev-text="'<'"
    :next-text="'>'"
    :first-last-button="false"
    :active-class="'current'"
    :click-handler="fetch">
  </paginate>
</div>
</template>

<script>
export default {
  name: 'Pagination',
  data: () => ({
    page: 1
  }),
  props: {
    pagination: {
      type: Object,
      required: true
    }
  },
  methods: {
    fetch () {
      this.$emit('update', this.page)
    },
    resetPagination () {
      this.page = 1
    }
  }
}
</script>

<style lang="scss">
.pagination {
  ul {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    li {
      margin: 0 1rem;
      &:first-child {
        font-weight: 900;
      }
      &:last-child {
        font-weight: 900;
      }
      a {
        color: gray;
        outline: none;
      }
    }
    .current {
      text-decoration: underline;
    }
  }
}
</style>